module.exports = __webpack_public_path__ + "img/list-segment-details.5637ec0a.png";